import { ILocale } from "src/consts/locale";

export const buildQueryUrl = ({ language, country }: ILocale, url: string, queryParams: URLSearchParams = new URLSearchParams()) => {
    queryParams.set("country", country);
    queryParams.set("language", language);

    const queryParamString = queryParams.toString();
    return `${url}${queryParamString ? `?${queryParamString}` : ""}`;
};
